import React from 'react';
import { Link } from 'react-router-dom';
//import blog3 from '../../images/blog-details/comments-author/img-1.jpg';
//import blog4 from '../../images/blog-details/comments-author/img-2.jpg';
//import blog5 from '../../images/blog-details/comments-author/img-3.jpg';
//import blog6 from '../../images/blog-details/author.jpg';
import blog7 from '../../images/blog-details/image-4.jpg';
import blog8 from '../../images/blog-details/image-5.jpg';
import blogs from '../../api/blogs';
import { useParams } from 'react-router-dom';

const BlogSingle = props => {
	const { slug } = useParams();

	const NewsDetails = blogs.find(item => item.slug === slug);

	const submitHandler = e => {
		e.preventDefault();
	};

	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<section className='py-[120px] md:py-[90px] sm:py-[80px]'>
			<div className='wraper'>
				<div className={`${props.gClass} grid gap-3`}>
					<div className={`col-span-8 md:col-span-12 ${props.blRight}`}>
						<div className=''>
							<div className='mb-[70px]'>
								<h3 className='text-[34px] md:text-[25px] sm:text-[22px] text-[#282e3f] font-normal font-heading-font leading-[40px] pt-7 transition-all mb-[20px] group'>
									<Link
										onClick={ClickHandler}
										to='/blog-single/Car-Accidents-Caused-by-Defective-Vehicles'
										className='group-hover:text-[#c0b596] transition-all'
									>
										{NewsDetails.title}
									</Link>
								</h3>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									{NewsDetails.description}
								</p>

								<blockquote
									className="relative bg-[#e4e0d4] text-[#333] text-[19px] p-[65px] mt-[60px] mb-[40px] text-center font-semibold leading-[35px] sm:px-[25px] sm:py-[55px]
                          before:font-['FontAwesome'] before:content-['\f10e'] before:text-[20px] before:absolute before:left-1/2 before:top-[-30px] before:translate before:-translate-x-1/2 before:w-[60px] before:h-[60px] before:leading-[60px]
                           before:border-[2px] before:border-[#eae7e7] before:bg-[#ddd5d5] before:text-[#333] before:rounded-full"
								>
									Those who do not know how to pursue pleasure rationally encounter consequences that
									are extremely painful.
								</blockquote>
								<p className='text-[#666] leading-[30px] text-[16px] mb-[20px]'>
									I will give you a complete account of the system, and expound the actual teachings
									of the great explorer of the truth, the master-builder of human happiness. No one
									rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because
									those who do not know how to pursue pleasure rationally encounter consequences that
									are extremely painful.
								</p>
								<img className='w-full' src={NewsDetails.blogSingleImg} alt='' />
								<div className='overflow-hidden mt-[40px] mx-[-7.5px]'>
									<div className='w-[calc(50%-15px)] float-left mx-[7.5px] mb-[15px]'>
										<img className='w-full' src={blog7} alt='' />
									</div>
									<div className='w-[calc(50%-15px)] float-left mx-[7.5px] mb-[15px]'>
										<img className='w-full' src={blog8} alt='' />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default BlogSingle;
